import App from './App.svelte';

const app = new App({
	target: document.getElementById('contact-form-container'),
	props: {}
});

export default app;